export interface FetchProps<Params> {
  params?: Params
  slug?: string
  id?: string | number
  onSuccess?: () => void
  config?: any
  uuKey?: string
}

export enum RequestMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}
